import ProgressBar from "../../../controls/ProgressBar";
import RadialProgress from "../../../controls/RadialProgress";
import { connect, PureComponentEx, translate, } from "../../../controls/ComponentEx";
import { sum } from "../../../util/util";
import * as React from "react";
class ProgressFooter extends PureComponentEx {
    render() {
        const { t, discovery, slim } = this.props;
        const phaseIds = Object.keys(discovery.phases);
        if (!discovery.running) {
            return null;
        }
        const totalProgress = sum(phaseIds.map((idx) => discovery.phases[idx].progress)) /
            phaseIds.length;
        if (slim) {
            return (React.createElement("div", null,
                React.createElement("div", { className: "discovery-footer-label" }, t("Scan")),
                React.createElement(RadialProgress, { totalRadius: 32, data: [
                        { min: 0, max: 100, value: totalProgress, class: "running" },
                    ] })));
        }
        else {
            return (React.createElement("div", { className: "discovery-footer" },
                React.createElement("div", { className: "discovery-footer-label" }, t("Game discovery")),
                React.createElement(ProgressBar, { min: 0, max: 100, now: totalProgress })));
        }
    }
}
function mapStateToProps(state) {
    return {
        discovery: state.session.discovery,
    };
}
export default translate(["common"])(connect(mapStateToProps)(ProgressFooter));
